import React, { Component } from 'react'

import CloseIcon from  '../partials/icons/close'    
import Store from '../store/ProductionTableStore'
import { observer } from 'mobx-react'
import GroupedBar from '../../charts/GroupedBar'
import DashStore from '../../dashboard/Store/DashStore'
import DatePicker, { utils } from 'react-modern-calendar-datepicker'
import { datepickerLocale } from '../../../helpers'

@observer
class ChangeOrderDatePopup extends Component {
    render() {
        if (Store.popupChangeDate.data.order == '') return '';

        const { show } = this.props
        let layout = null
        let classes = ''

        const productionDate = {
            year: parseInt(Store.popupChangeDate.data.order.production_date.substr(0,4)),
            month: parseInt(Store.popupChangeDate.data.order.production_date.substr(5,2)),
            day: parseInt(Store.popupChangeDate.data.order.production_date.substr(8,2)),
        };

        const deliveryDate = {
            year: parseInt(Store.popupChangeDate.data.order.delivery_date.substr(0,4)),
            month: parseInt(Store.popupChangeDate.data.order.delivery_date.substr(5,2)),
            day: parseInt(Store.popupChangeDate.data.order.delivery_date.substr(8,2)),
        };

        if (show) {
            classes = 'popup--show'
        }

        let deliveryDateHtml = '';
        let notifyCustomerAboutDeliveryDateChange = '';

        if (Store.popupChangeDate.data.locked) {
            deliveryDateHtml = <div>
                                    <input type="text" readOnly value={Store.popupChangeDate.data.order.delivery_date}/>
                                    <i className="fas fa-lock" onClick={Store.UNLOCK_ORDER} title="Klicka för att låsa upp leveransdatum"></i>
                                </div>
            
        } else {
            deliveryDateHtml = <DatePicker
                                    onChange={(newValue) => Store.HANDLE_DELIVERY_DATE_CHANGE(newValue)}
                                    locale={ datepickerLocale.sv }
                                    inputPlaceholder="Ändra leveransdatum"
                                    formatInputText={() => {return this.formatDateInput(deliveryDate)}}
                                    value={ deliveryDate }
                                    minimumDate={ productionDate }
                                    disabled="disabled"
                                />

            notifyCustomerAboutDeliveryDateChange = <React.Fragment>
                <label>Anledning till ändrat leveransdatum</label>
                <textarea name="" onBlur={(e) => {Store.popupChangeDate.data.delivery_change_reason = e.target.value;}}></textarea>
                <div className="deliveryDateCheckbox"><input type="checkbox" value="1" onChange={(e) => {
                Store.popupChangeDate.data.notify_delivery_date_change = e.target.checked;
            }}/>Meddela kund om nytt leveransdatum</div></React.Fragment    >
        }
        
        layout = <div className="change-order-date">
            <div className="change-order-date__header">
                <h2 className="change-order-date__header__title">Ändra produktions- och leveransdatum</h2>
                <p>{Store.popupChangeDate.data.order.cost_estimate.name} (kalkylnr. {Store.popupChangeDate.data.order.cost_estimate.id})</p>
            </div>
            <div className="change-order-date__reservation-chart"><GroupedBar chartOpt={ DashStore.reservationChart } /></div>
            <div className="change-order-date__main">
                <div className="change-order-date__main__item">
                    <label className="change-order-date__main__item__label">Produktionsdatum</label>
                    <DatePicker
                        onChange={(newValue) => Store.HANDLE_PRODUCTION_DATE_CHANGE(newValue)}
                        locale={ datepickerLocale.sv }
                        inputPlaceholder="Ändra produktionsdatum"
                        formatInputText={() => {return this.formatDateInput(productionDate)}}
                        value={ productionDate }
                        maximumDate={ deliveryDate }
                    />
                </div>
                <div className="change-order-date__main__item">
                    <label className="change-order-date__main__item__label">Leveransdatum</label>
                    { deliveryDateHtml }
                </div>
                <div className="change-order-date__main__item">
                    <label className="change-order-date__main__item__label">&nbsp;</label>
                    <button onClick={ Store.HANDLE_SAVE_DATE_POP_UP } className="btn btn-icon btn-icon--save">Spara</button>
                </div>
            </div>
            {notifyCustomerAboutDeliveryDateChange}
        </div>

        return <div className={ `popup ${ classes }` }>
            <div className="popup__inner popup__inner--change-date">
                <header className="popup__inner__header">
                    <span className="popup__inner__header__close" onClick={ Store.HANDLE_CLOSE_DATE_POP_UP }>
                        Stäng
                        <CloseIcon />
                    </span>
                </header>

                <div className="popup__inner__main">
                    { layout }
                </div>
            </div>
        </div>
    }

    formatDateInput = (theDate) => {
        const year = theDate.year.toString();
		const month = theDate.month.toString().padStart(2, 0);
		const day = theDate.day.toString().padStart(2, 0);
		return `${year}-${month}-${day}`;
    }
}

export default ChangeOrderDatePopup
